/* global showInfoToast */
import React, { useState, useEffect } from "react";
import { getCsv, getTargetGroups, getTargetNames, getTargets, getTargetItems, getTargetTypes, getShiftUsers } from "../api/api";
import Papa from "papaparse";
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ReferenceLine, Label } from 'recharts';
import { Pie, PieChart } from 'recharts';
import Calendar from "./tools/Calendar";
import FooterBar from "./layout/FooterBar";
import FooterButton from "./tools/FooterButton";

const Statistiche = (props) => {
    const companyID = props.userDetails?.Company?.[0]?.dataID || null;
    const [selectedMonth, setSelectedMonth] = useState(null);

    const [selectedDate, setSelectedDate] = useState(() => {
        const now = new Date();
        setSelectedMonth(`${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}`);
        return now.toISOString().slice(0, 10); // "YYYY-MM-DD"
    });

    const [selectedDay, setSelectedDay] = useState(() => {
        const now = new Date();
        return now.getDate();
    });

    // Funzione per ottenere il nome del mese in italiano
    const getMonthName = (monthString) => {
        const [year, month] = monthString.split("-");
        const date = new Date(year, month - 1);
        return date.toLocaleString("it-IT", { month: "long", year: "numeric" });
    };

    // Funzione per calcolare la percentuale di avanzamento del mese
    const getMonthProgressPercentage = (monthString) => {
        const [year, month] = monthString.split("-");
        const now = new Date();
        const currentDay = new Date(selectedDate).getDate();
        const daysInMonth = new Date(year, month, 0).getDate();
        return (currentDay / daysInMonth) * 100;
    };

    const showGroup = (target) => {
        if (target === "all") {
            const totalsCardElements = document.querySelectorAll(`.totals-card`);
            totalsCardElements.forEach(el => el.classList.remove("hidden"));
            return;
        }
        const totalsCardElements = document.querySelectorAll(`.totals-card`);
        totalsCardElements.forEach(el => el.classList.add("hidden"));
        const targetGroupElements = document.querySelectorAll(`[operator="${target}"]`);
        targetGroupElements.forEach(el => el.classList.remove("hidden"));
    };

    const fetchShiftUsers = async () => {
        try {
            const response = await getShiftUsers(companyID, selectedMonth);
            setShiftUsers(response.data.data.getShiftUserListing.edges); // Imposta gli utenti nello stato
            console.log("Fetched users:", response.data.data.getShiftUserListing.edges);
            return response.data.data.getShiftUserListing.edges;
        } catch (error) {
            console.error("Error fetching users:", error);
            return [];
        }
    };

    const fetchTargets = async () => {
        try {
            const response = await getTargets(companyID, "", "", selectedMonth);
            setTargets(response.data.data.getTargetListing.edges); // Imposta i target nello stato
            // console.log("Fetched targets:", response.data.data.getTargetListing.edges);
            return response.data.data.getTargetListing.edges;
        } catch (error) {
            console.error("Error fetching targets:", error);
            return [];
        }
    };

    const fetchTargetItems = async () => {
        try {
            const response = await getTargetItems(companyID, 1000000, 0, selectedMonth);
            setTargetItems(response.data.data.getTargetItemListing.edges); // Imposta i target items nello stato
            // console.log("Fetched target items:", response.data.data.getTargetItemListing.edges);
            return response.data.data.getTargetItemListing.edges;
        } catch (error) {
            console.error("Error fetching target items:", error);
            return [];
        }
    };

    const fetchTargetTypes = async () => {
        try {
            const response = await getTargetTypes(companyID, "", "", selectedMonth);
            setTargetTypes(response.data.data.getTargetTypeListing.edges); // Imposta i tipi target nello stato
            return response.data.data.getTargetTypeListing.edges;
        } catch (error) {
            console.error("Error fetching target types:", error);
            return [];
        }
    };

    const [shiftUsers, setShiftUsers] = useState(null); // <-- aggiungi stato per gli utenti
    const [loading, setLoading] = useState(false); // <-- aggiungi stato loading
    const [csvData, setCsvData] = useState(null); // <-- aggiungi stato per i dati
    const [csvPoints, setCsvPoints] = useState(null); // <-- aggiungi stato per i punti
    const [csvTypes, setCsvTypes] = useState(null); // <-- aggiungi stato per i tipi CSV
    const [csvGroup, setCsvGroup] = useState({}); // <-- aggiungi stato per i gruppi CSV
    const [csvDataToday, setCsvDataToday] = useState(null); // <-- aggiungi stato per i dati di oggi
    const [targetGroups, setTargetGroups] = useState(null); // <-- aggiungi stato per i gruppi target
    const [targetNames, setTargetNames] = useState(null); // <-- aggiungi stato per i nomi target
    const [targets, setTargets] = useState(null); // <-- aggiungi stato per i nomi target
    const [targetTypes, setTargetTypes] = useState(null); // <-- aggiungi stato per i tipi target
    const [targetItems, setTargetItems] = useState(null); // <-- aggiungi stato per i nomi target
    const [parsedData, setParsedData] = useState(null); // <-- aggiungi stato per i dati parsati
    const [selectedPDV, setSelectedPDV] = useState(null); // <-- aggiungi stato per il PDV selezionato

    useEffect(() => {
        setSelectedDay(new Date(selectedDate).getDate()); // Aggiorna selectedDay quando selectedDate cambia
        setSelectedMonth(selectedDate.slice(0, 7)); // Aggiorna selectedMonth quando selectedDate cambia
    }, [selectedDate]); // Ricarica i dati quando cambia il mese

    useEffect(() => {
        setLoading(true); // Imposta loading a true all'inizio del caricamento dei dati
    }, [selectedMonth]); // Ricarica i dati quando cambia il mese

    // useEffect(() => {
    //     if (!targetGroups || !parsedData || !parsedData.data) return; // Se i gruppi target o i dati parsati non sono ancora caricati, non fare nulla

    //     const totals = parsedData.data.reduce((acc, item) => {
    //         const targetGroup = targetGroups?.find(t => item.TARGET.includes(t.node.master))?.node.master;
    //         const key = `${targetGroup}-${item.GRUPPO}`;
    //         const dateStr = item.DATADOC; // Formato DD/MM/YYYY
    //         const formattedDate = `${dateStr.slice(6, 10)}-${dateStr.slice(3, 5)}-${dateStr.slice(0, 2)}`; // Converti in YYYY-MM-DD
    //         const pdv = item.PUNTOVENDITA; // Aggiungi il PDV
    //         if (selectedPDV && pdv !== selectedPDV) {
    //             return acc; // Salta questo item se il PDV non corrisponde a quello selezionato
    //         }

    //         if (formattedDate > selectedDate) {
    //             return acc; // Salta questo item se la data è superiore a quella selezionata
    //         }

    //         if (!acc[key]) {
    //             acc[key] = 0;
    //         }

    //         if (item.VALENZA === undefined) {
    //             return acc; // Salta questo item se manca il campo VALENZA
    //         } else {
    //             acc[key] += parseFloat(item.VALENZA.replace(",", ".")) || 0;
    //         }
    //         return acc;
    //     }, {});

    //     const totalsToday = parsedData.data.reduce((acc, item) => {
    //         const targetGroup = targetGroups?.find(t => item.TARGET.includes(t.node.master))?.node.master;
    //         const key = `${targetGroup}-${item.GRUPPO}`;
    //         const dateStr = item.DATADOC; // Formato DD/MM/YYYY
    //         const formattedDate = `${dateStr.slice(6, 10)}-${dateStr.slice(3, 5)}-${dateStr.slice(0, 2)}`; // Converti in YYYY-MM-DD
    //         const pdv = item.PUNTOVENDITA; // Aggiungi il PDV
    //         if (selectedPDV && pdv !== selectedPDV) {
    //             return acc; // Salta questo item se il PDV non corrisponde a quello selezionato
    //         }

    //         if (formattedDate !== selectedDate) {
    //             return acc; // Salta questo item se la data non corrisponde a quella selezionata
    //         }

    //         if (!acc[key]) {
    //             acc[key] = 0;
    //         }

    //         if (item.VALENZA === undefined) {
    //             return acc; // Salta questo item se manca il campo VALENZA
    //         } else {
    //             acc[key] += parseFloat(item.VALENZA.replace(",", ".")) || 0;
    //         }
    //         return acc;
    //     }, {});

    //     setCsvDataToday(totalsToday); // Imposta i dati di oggi nel componente
    //     setCsvData(totals); // Imposta i dati nel componente
    //     console.log("Calculated totals:", totals);
    //     setLoading(false); // Imposta loading a false quando i dati sono caricati
    // }, [parsedData, selectedDate, selectedPDV]); // Ricarica i dati quando cambia il mese

    useEffect(() => {
        if (companyID) {
            setSelectedPDV(null); // Resetta il PDV selezionato quando cambia il mese
            // setSelectedPDV("MASCALI"); // Imposta un PDV di default per il test
            const thisMonth = selectedMonth.split("-")[1] + selectedMonth.split("-")[0];

            fetchTargets(); // <-- chiama la funzione per fetchare i target
            fetchTargetItems(); // <-- chiama la funzione per fetchare i target items
            fetchTargetTypes(); // <-- chiama la funzione per fetchare i tipi target
            fetchShiftUsers(); // <-- chiama la funzione per fetchare gli utenti
            console.log("Fetching users...");
            console.log("Current users state:", shiftUsers);

            try {
                // Flusso sequenziale: getTargetNames -> getTargetGroups -> getCsv
                getTargetNames(companyID, selectedDate.slice(0, 7), "")
                    .then(response => {
                        setTargetNames(response.data.data.getTargetNameListing.edges); // Imposta i nomi target nello stato

                        // Proceed to getTargetGroups
                        return getTargetGroups(companyID, selectedDate.slice(0, 7), "");
                    })
                    .then(response => {
                        setTargetGroups(response.data.data.getTargetGroupListing.edges); // Imposta i gruppi target nello stato

                        // Proceed to getCsv
                        // return getCsv(companyID, thisMonth);
                    })
                    .then(response => {
                        // const csvData = response.data;
                        // if (!csvData) {
                        //     setParsedData({}); // Imposta dati vuoti se la risposta è vuota
                        //     setCsvData(null); // Resetta i dati CSV prima di ricalcolarli con i nuovi dati parsati
                        //     setLoading(false); // Imposta loading a false anche in caso di dati vuoti
                        //     return;
                        // }
                        // const parsedData = Papa.parse(csvData, { header: true, skipEmptyLines: true });
                        // setParsedData(parsedData); // Imposta i dati parsati nello stato
                        setLoading(false); // Imposta loading a false quando tutti i dati sono caricati
                    })
                    .catch(error => {
                        console.error("Error fetching data:", error);
                        setParsedData({}); // Imposta dati vuoti in caso di errore
                        setLoading(false); // Imposta loading a false in caso di errore
                    });
            } catch (error) {
                console.error("Error in data fetching flow:", error);
                setParsedData({}); // Imposta dati vuoti in caso di errore
                setLoading(false); // Imposta loading a false in caso di errore
            }
        }
    }, [selectedMonth, companyID]); // Carica i dati quando cambia il mese

    useEffect(() => {
        if (targets && targetItems) {
            const csvDataMap = {};
            const csvPointsMap = {};
            const csvDataToday = {};
            const csvTypesMap = {};
            const csvGroupsMap = {};
            var target = null;

            targetItems.forEach(item => {
                const targetName = item.node.Target[0]?.name;
                targets.find(
                    t => {
                        target = t;
                        return t.node.name === targetName
                    }
                )?.node.TargetType_points?.forEach(
                    tt => {
                        if (item.node.date.slice(0, 10) > selectedDate) {
                            return; // Salta questo item se la data è superiore a quella selezionata
                        }
                        const matchingTarget = tt.name.toUpperCase()
                        const matchingGroup = targetGroups?.find(t => targetName.substring(0, 3).includes(t.node.master))?.node.master;
                        if (matchingTarget && matchingGroup) {
                            csvTypesMap[matchingTarget] = parseFloat(csvTypesMap[matchingTarget] || 0) + parseFloat(1); // Incrementa il conteggio per il tipo
                            csvDataMap[matchingGroup + "-" + matchingTarget] = parseFloat(csvDataMap[matchingGroup + "-" + matchingTarget] || 0) + parseFloat(1); // Incrementa il conteggio per questa combinazione di gruppo e target
                            csvPointsMap[matchingGroup + "-" + matchingTarget] = parseFloat(csvPointsMap[matchingGroup + "-" + matchingTarget] || 0) + parseFloat(target.node.points); // Incrementa il conteggio per questa combinazione di gruppo e target
                            if (item.node.date.slice(0, 10) === selectedDate) {
                                // console.log("Item for today:", item);
                                csvDataToday[matchingGroup + "-" + matchingTarget] = parseFloat(csvDataToday?.[matchingGroup + "-" + matchingTarget] || 0) + parseFloat(target.node.points); // Incrementa il conteggio per questa combinazione di gruppo e target
                            }
                        }
                    }
                );
            });

            targetGroups?.forEach(group => {
                const matchingTarget = group.node.name.toUpperCase();
                // console.log("Matching target for group:", matchingTarget, group.node.val);
                csvGroupsMap[matchingTarget] = parseFloat(csvGroupsMap[matchingTarget] || 0) + parseFloat(group.node.val); // Incrementa il conteggio per il gruppo
            });

            // console.log("CSV Data Map:", csvDataMap);
            // console.log("CSV Points Map:", csvPointsMap);
            // console.log("CSV Data Today:", csvDataToday);
            // console.log("CSV Types Map:", csvTypesMap);
            // console.log("CSV Groups Map:", csvGroupsMap);
            setCsvData(csvPointsMap);
            setCsvPoints(csvDataMap);
            setCsvDataToday(csvDataToday);
            setCsvTypes(csvTypesMap);
            setCsvGroup(csvGroupsMap);
        }
    }, [targets, targetItems, targetGroups, selectedDate, selectedPDV]);

    return (
        <div className="container-fluid">
            {loading ? (
                <div className="text-center my-4">
                    <div className="spinner-border text-primary" role="status">
                        <span className="sr-only">Loading...</span>
                    </div>
                </div>
            ) : (
                <>
                    <div className="row clearfix justify-content-center mb-10">
                        {targetTypes?.map(tt => (
                            tt.node.isStats ? (
                                <React.Fragment key={tt.node.name + "stats"}>
                                    <a href="#nothing" className="col-md-auto col-sm-12">
                                        <div className="card proj-t-card">
                                            <div className="card-body">
                                                {(() => {
                                                    const targetTypeTotal = csvTypes ? csvTypes[tt.node.name.toUpperCase()] || 0 : 0;
                                                    const targetTypeVal = csvGroup ? csvGroup[tt.node.name.toUpperCase()] || 0 : 0;
                                                    const targetPercentage = targetTypeVal > 0 ? (targetTypeTotal / targetTypeVal) * 100 : 0;
                                                    const data = [
                                                        { name: tt.node.name, value: parseFloat(targetPercentage.toFixed(2)), fill: "#0471FF" },
                                                        { name: "RIMANENTE", value: parseFloat((100 - targetPercentage).toFixed(2)), fill: "#EFEFEF" }
                                                    ];
                                                    const dataProgress = [
                                                        { name: "PROGRAMMATO", value: parseFloat(getMonthProgressPercentage(selectedMonth).toFixed(2)), fill: "#000000" },
                                                        { name: "PROGRAMMATO", value: parseFloat((100 - getMonthProgressPercentage(selectedMonth)).toFixed(2)), fill: "#EFEFEF" }
                                                    ];
                                                    const CircularImageLabel = () => {
                                                        const cx = 40;
                                                        const cy = 40;
                                                        const size = "100%"; // Dimensione del box dell'immagine

                                                        return (
                                                            // 1. foreignObject crea l'area HTML dentro l'SVG
                                                            <foreignObject
                                                                x={-2}
                                                                y={22}
                                                                width={size}
                                                                height={size}
                                                            >
                                                                <div className="row align-items-center mt-5 mb-20">
                                                                    <div className="col-12 text-center">
                                                                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%', height: '100%' }}>
                                                                            {tt.node.icon && <span className="rounded-circle bg-white p-2 material-symbols-outlined text-dark" style={{ fontSize: cx + "px" }}>{tt.node.icon}</span>}
                                                                        </div>
                                                                    </div>
                                                                    <div className="col-12 m-0 p-0">
                                                                        <h6 className={`m-0 text-center text-dark`}>{tt.node.name && tt.node.name.toUpperCase()}</h6>
                                                                    </div>
                                                                    <div className="col-12">
                                                                        <div className="mb-2">
                                                                            <h6 className="mb-0 font-weight-bold text-dark text-center">{csvTypes ? csvTypes[tt.node.name.toUpperCase()] || 0 : 0}<small className="text-muted"> / {targetTypeVal || 0}</small></h6>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </foreignObject>
                                                        );
                                                    };
                                                    return (
                                                        <PieChart
                                                            style={{ width: '100%', height: '160px', aspectRatio: 1 }}
                                                            responsive
                                                            margin={{
                                                                top: 0,
                                                                right: 0,
                                                                bottom: 0,
                                                                left: 0,
                                                            }}
                                                        >

                                                            <Label content={<CircularImageLabel />} position="center" />

                                                            <Pie
                                                                data={dataProgress}
                                                                cx="50%"
                                                                cy="50%"
                                                                innerRadius="80%"
                                                                outerRadius="85%"
                                                                fill={["#8884d8", "#82ca9d", "#ffc658", "#ff8042"]}
                                                                dataKey="value"
                                                                isAnimationActive={true}
                                                                fillOpacity={0.70}
                                                            />

                                                            <Pie
                                                                data={data}
                                                                cx="50%"
                                                                cy="50%"
                                                                innerRadius="85%"
                                                                outerRadius="100%"
                                                                fill={["#8884d8", "#82ca9d", "#ffc658", "#ff8042"]}
                                                                dataKey="value"
                                                                isAnimationActive={true}
                                                                fillOpacity={0.70}
                                                            />
                                                            <Tooltip contentStyle={{ backgroundColor: '#ffffff', border: '1px solid #ccc', borderRadius: '4px', fontWeight: 'bold' }} />
                                                        </PieChart>
                                                    )
                                                })()}
                                            </div>
                                        </div>
                                    </a>
                                </React.Fragment>
                            ) : null
                        ))}
                        {shiftUsers?.map(user => (
                            user.node ? (
                                <React.Fragment>   
                                    {/* {user.node.CompanyOffice[0].name!="Admin" ? user.node.User[0].username : null} */}
                                </React.Fragment>
                                // <React.Fragment key={user.node.name + "stats"}>
                                //     <a href="#nothing" className="col-md-auto col-sm-12">
                                //         <div className="card proj-t-card">
                                //             <div className="card-body">
                                //                 {(() => {
                                //                     const targetTypeTotal = csvTypes ? csvTypes[user.node.name.toUpperCase()] || 0 : 0;
                                //                     const targetTypeVal = csvGroup ? csvGroup[user.node.name.toUpperCase()] || 0 : 0;
                                //                     const targetPercentage = targetTypeVal > 0 ? (targetTypeTotal / targetTypeVal) * 100 : 0;
                                //                     const data = [
                                //                         { name: user.node.name, value: parseFloat(targetPercentage.toFixed(2)), fill: "#0471FF" },
                                //                         { name: "RIMANENTE", value: parseFloat((100 - targetPercentage).toFixed(2)), fill: "#EFEFEF" }
                                //                     ];
                                //                     const dataProgress = [
                                //                         { name: "PROGRAMMATO", value: parseFloat(getMonthProgressPercentage(selectedMonth).toFixed(2)), fill: "#000000" },
                                //                         { name: "PROGRAMMATO", value: parseFloat((100 - getMonthProgressPercentage(selectedMonth)).toFixed(2)), fill: "#EFEFEF" }
                                //                     ];
                                //                     const CircularImageLabel = () => {
                                //                         const cx = 40;
                                //                         const cy = 40;
                                //                         const size = "100%"; // Dimensione del box dell'immagine

                                //                         return (
                                //                             // 1. foreignObject crea l'area HTML dentro l'SVG
                                //                             <foreignObject
                                //                                 x={-2}
                                //                                 y={22}
                                //                                 width={size}
                                //                                 height={size}
                                //                             >
                                //                                 <div className="row align-items-center mt-5 mb-20">
                                //                                     <div className="col-12 text-center">
                                //                                         <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%', height: '100%' }}>
                                //                                             {tt.node.icon && <span className="rounded-circle bg-white p-2 material-symbols-outlined text-dark" style={{ fontSize: cx + "px" }}>{tt.node.icon}</span>}
                                //                                         </div>
                                //                                     </div>
                                //                                     <div className="col-12 m-0 p-0">
                                //                                         <h6 className={`m-0 text-center text-dark`}>{tt.node.name && tt.node.name.toUpperCase()}</h6>
                                //                                     </div>
                                //                                     <div className="col-12">
                                //                                         <div className="mb-2">
                                //                                             <h6 className="mb-0 font-weight-bold text-dark text-center">{csvTypes ? csvTypes[tt.node.name.toUpperCase()] || 0 : 0}<small className="text-muted"> / {targetTypeVal || 0}</small></h6>
                                //                                         </div>
                                //                                     </div>
                                //                                 </div>
                                //                             </foreignObject>
                                //                         );
                                //                     };
                                //                     return (
                                //                         <PieChart
                                //                             style={{ width: '100%', height: '160px', aspectRatio: 1 }}
                                //                             responsive
                                //                             margin={{
                                //                                 top: 0,
                                //                                 right: 0,
                                //                                 bottom: 0,
                                //                                 left: 0,
                                //                             }}
                                //                         >

                                //                             <Label content={<CircularImageLabel />} position="center" />

                                //                             <Pie
                                //                                 data={dataProgress}
                                //                                 cx="50%"
                                //                                 cy="50%"
                                //                                 innerRadius="80%"
                                //                                 outerRadius="85%"
                                //                                 fill={["#8884d8", "#82ca9d", "#ffc658", "#ff8042"]}
                                //                                 dataKey="value"
                                //                                 isAnimationActive={true}
                                //                                 fillOpacity={0.70}
                                //                             />

                                //                             <Pie
                                //                                 data={data}
                                //                                 cx="50%"
                                //                                 cy="50%"
                                //                                 innerRadius="85%"
                                //                                 outerRadius="100%"
                                //                                 fill={["#8884d8", "#82ca9d", "#ffc658", "#ff8042"]}
                                //                                 dataKey="value"
                                //                                 isAnimationActive={true}
                                //                                 fillOpacity={0.70}
                                //                             />
                                //                             <Tooltip contentStyle={{ backgroundColor: '#ffffff', border: '1px solid #ccc', borderRadius: '4px', fontWeight: 'bold' }} />
                                //                         </PieChart>
                                //                     )
                                //                 })()}
                                //             </div>
                                //         </div>
                                //     </a>
                                // </React.Fragment>
                            ) : null
                        ))}
                        <div className="w-100"></div>
                        {targetNames && targetNames.map((target) => (
                            <React.Fragment key={target.node.name + "charts"}>
                                <a href="#nothing" data-toggle="modal" onClick={() => showGroup(target.node.name)} data-target="#modalTargets" className="col-md-auto col-sm-12">
                                    <div className="card proj-t-card">
                                        <div className="card-header p-2 px-3">
                                            <h5 className={`card-title m-0 w-100 text-center text-dark`}>{target.node.name}</h5>
                                        </div>
                                        <div className="card-body">
                                            <BarChart
                                                style={{ width: '100%', maxWidth: '380px', maxHeight: '120px', aspectRatio: 1.618 }}
                                                responsive
                                                data={targetGroups ?
                                                    targetGroups.map(
                                                        group => (target.node.name == group.node.targetName ?
                                                            {
                                                                name: group.node.label, [target.node.name]: group.node.val > 0 ?
                                                                    (csvData?.[group.node.master + "-" + group.node.name]) ?
                                                                        (csvData[group.node.master + "-" + group.node.name] / group.node.val * 100).toFixed(2)
                                                                        : 0
                                                                    : 0
                                                            }
                                                            : null)).filter(Boolean)
                                                    : []}
                                                margin={{
                                                    top: 5,
                                                    right: 0,
                                                    left: 0,
                                                    bottom: -10,
                                                }}
                                            >
                                                <CartesianGrid strokeDasharray="3 3" />
                                                <XAxis dataKey="name" />
                                                <YAxis width="auto" />
                                                <YAxis domain={[0, 100]} ticks={[0, 25, 50, 75, 100]} />
                                                <ReferenceLine y={getMonthProgressPercentage(selectedMonth)} stroke="var(--dark-text, var(--light-text))" strokeWidth={1.5} />
                                                <Bar dataKey={target.node.name} fill={target.node.Carrier[0].codeColor} activeBar={{ fill: target.node.Carrier[0].codeColor, stroke: 'white' }} radius={[0, 0, 0, 0]} fillOpacity={0.70} />
                                            </BarChart>
                                        </div>
                                    </div>
                                </a>
                            </React.Fragment>
                        ))}
                        <a href="#nothing" className="col-md-auto col-sm-12" onClick={() => showGroup("all")} data-toggle="modal" data-target="#modalTargets">
                            <div className="card proj-t-card">
                                <div className="card-header p-2 px-3">
                                    <h5 className={`card-title m-0 w-100 text-center text-dark`}>PESI OPERATORI</h5>
                                </div>
                                <div className="card-body p-0">
                                    {(() => {
                                        const data = targetNames ? targetNames.map(target => {
                                            return { name: target.node.name, value: target.node.share, fill: target.node.Carrier[0].codeColor };
                                        }) : [];
                                        return (
                                            <PieChart
                                                style={{ width: '100%', height: '160px', aspectRatio: 1 }}
                                                responsive
                                                margin={{
                                                    top: 0,
                                                    right: 0,
                                                    bottom: 0,
                                                    left: 0,
                                                }}
                                            >
                                                <Pie
                                                    data={data}
                                                    cx="50%"
                                                    cy="50%"
                                                    innerRadius="60%"
                                                    outerRadius="80%"
                                                    fill={["#8884d8", "#82ca9d", "#ffc658", "#ff8042"]}
                                                    dataKey="value"
                                                    isAnimationActive={true}
                                                    fillOpacity={0.70}
                                                />
                                                <Tooltip contentStyle={{ backgroundColor: '#ffffff', border: '1px solid #ccc', borderRadius: '4px', fontWeight: 'bold' }} />
                                            </PieChart>
                                        )
                                    })()}
                                </div>
                            </div>
                        </a>
                    </div>
                    <div>
                        {/* Modal targets*/}
                        <div className="modal fade" id="modalTargets" tabIndex={-1} role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
                            <div className="modal-dialog" role="document" style={{ backdropFilter: 'blur(4px)', maxWidth: "100vw", maxHeight: "100vh", width: "100vw", height: "100vh", margin: 0, overflowY: "auto" }}>
                                <div className="modal-content border-0" style={{ backgroundColor: 'rgba(255, 255, 255, 0)' }}>
                                    <div className="modal-body" data-dismiss="modal">
                                        <div className="row clearfix justify-content-center mb-10">
                                            {csvData && targetNames && targetNames.map((target) => (
                                                <React.Fragment key={target.node.name + "stats"}>
                                                    {targetGroups && targetGroups.map(group => {
                                                        const targetGroupName = group.node.name;
                                                        const targetGroupLabel = group.node.label;
                                                        const targetGroupIcon = group.node.TargetType[0].icon || "";
                                                        const targetGroupThresholds = group.node.TargetThreshold || [];
                                                        const countThresholds = targetGroupThresholds.length;
                                                        const targetName = group.node.master;
                                                        const key = `${targetName}-${targetGroupName}`;
                                                        const targetTotal = csvData?.[key] || 0;
                                                        const targetGroupColor = target.node.Carrier[0].color;
                                                        const targetGroupCarrierLogo = target.node.Carrier[0].logo.fullpath;
                                                        const targetGroupVal = group.node.val || 0;
                                                        const targetPercentage = targetGroupVal > 0 ? (targetTotal / targetGroupVal) * 100 : 0;

                                                        if (group.node.targetName !== target.node.name) {
                                                            return null; // Salta questo gruppo se il TargetType non corrisponde al target corrente
                                                        }

                                                        return (<a href="#nothing" key={key} data-toggle="modal" className="col-md-auto col-sm-12 totals-card hidden" operator={target.node.name}>
                                                            <div className="card proj-t-card">
                                                                <div className="card-body">
                                                                    {(() => {
                                                                        const data = [
                                                                            { name: target.node.name, value: parseFloat(targetPercentage.toFixed(2)), fill: target.node.Carrier[0].codeColor },
                                                                            { name: "RIMANENTE", value: parseFloat((100 - targetPercentage).toFixed(2)), fill: "#EFEFEF" }
                                                                        ];
                                                                        const dataProgress = [
                                                                            { name: "PROGRAMMATO", value: parseFloat(getMonthProgressPercentage(selectedMonth).toFixed(2)), fill: "#000000" },
                                                                            { name: "PROGRAMMATO", value: parseFloat((100 - getMonthProgressPercentage(selectedMonth)).toFixed(2)), fill: "#EFEFEF" }
                                                                        ];
                                                                        const CircularImageLabel = () => {
                                                                            const cx = 40;
                                                                            const cy = 40;
                                                                            const size = "100%"; // Dimensione del box dell'immagine

                                                                            return (
                                                                                // 1. foreignObject crea l'area HTML dentro l'SVG
                                                                                <foreignObject
                                                                                    x={-2}
                                                                                    y={22}
                                                                                    width={size}
                                                                                    height={size}
                                                                                >
                                                                                    <div className="row align-items-center mt-5 mb-20">
                                                                                        <div className="col-12 text-center">
                                                                                            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%', height: '100%' }}>
                                                                                                {targetGroupIcon && <span className="rounded-circle bg-white p-2 material-symbols-outlined text-dark" style={{ fontSize: cx + "px" }}>{targetGroupIcon}</span>}
                                                                                            </div>
                                                                                        </div>
                                                                                        <div className="col-12 m-0 p-0">
                                                                                            <h6 className={`m-0 text-center text-dark`}>{targetGroupLabel && targetGroupLabel.toUpperCase()}</h6>
                                                                                        </div>
                                                                                        <div className="col-12">
                                                                                            <div className="mb-2">
                                                                                                <h6 className="mb-0 font-weight-bold text-dark text-center">{targetTotal}<small className="text-muted"> / {targetGroupVal}</small></h6>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                </foreignObject>
                                                                            );
                                                                        };
                                                                        return (
                                                                            <PieChart
                                                                                style={{ width: '100%', height: '160px', aspectRatio: 1 }}
                                                                                responsive
                                                                                margin={{
                                                                                    top: 0,
                                                                                    right: 0,
                                                                                    bottom: 0,
                                                                                    left: 0,
                                                                                }}
                                                                            >

                                                                                <Label content={<CircularImageLabel />} position="center" />

                                                                                <Pie
                                                                                    data={dataProgress}
                                                                                    cx="50%"
                                                                                    cy="50%"
                                                                                    innerRadius="80%"
                                                                                    outerRadius="85%"
                                                                                    fill={["#8884d8", "#82ca9d", "#ffc658", "#ff8042"]}
                                                                                    dataKey="value"
                                                                                    isAnimationActive={true}
                                                                                    fillOpacity={0.70}
                                                                                />

                                                                                <Pie
                                                                                    data={data}
                                                                                    cx="50%"
                                                                                    cy="50%"
                                                                                    innerRadius="85%"
                                                                                    outerRadius="100%"
                                                                                    fill={["#8884d8", "#82ca9d", "#ffc658", "#ff8042"]}
                                                                                    dataKey="value"
                                                                                    isAnimationActive={true}
                                                                                    fillOpacity={0.70}
                                                                                />
                                                                                <Tooltip contentStyle={{ backgroundColor: '#ffffff', border: '1px solid #ccc', borderRadius: '4px', fontWeight: 'bold' }} />
                                                                            </PieChart>
                                                                        )
                                                                    })()}
                                                                    <div className="row align-items-center text-center">
                                                                        <div className="col">
                                                                            {(() => {
                                                                                const nextThreshold = targetGroupThresholds && targetGroupThresholds.find(t => t.minimumValue > targetTotal);
                                                                                if (nextThreshold) {
                                                                                    const pointsNeeded = nextThreshold.minimumValue - targetTotal;
                                                                                    return <strong className="text-gray big-number">-{pointsNeeded}</strong>;
                                                                                }
                                                                                return <small className="text-success big-number">✓</small>;
                                                                            })()}
                                                                        </div>
                                                                        <div className="col">
                                                                            {csvDataToday?.[key] ? <strong className="text-success big-number">{"+" + csvDataToday?.[key]}</strong> : ""}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="card-footer p-0">
                                                                    {targetGroupThresholds && targetGroupThresholds.map((threshold, index) => (
                                                                        <span key={index} className={`badge rounded-0 ${targetTotal >= threshold.minimumValue ? 'badge-primary' : 'text-muted'}`} style={{ width: `${100 / countThresholds}%` }}>
                                                                            {threshold.minimumValue}
                                                                            {threshold.isBonus ? '\u00A0🏆' : ''}
                                                                        </span>
                                                                    ))}
                                                                </div>
                                                            </div>
                                                        </a>);
                                                    })
                                                    }
                                                </React.Fragment>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>


                    <FooterBar
                        footerIcon={"bar_chart_4_bars"}
                        footerTitle={"Statistiche"}
                        footerButton={
                            <FooterButton icon="settings" title="Impostazioni" action={() => showInfoToast("Disponibile nel prossimo aggiornamento")} />
                        }
                        footerPlugin={<Calendar selectedDate={selectedDate} setSelectedDate={setSelectedDate} />}
                    />
                </>
            )}
        </div >
    );
};
export default Statistiche;